<template>
  <div>
    <nav class="navigation navigation__breadcrumb">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        aria-label="Breadcrumb navigation"
      >
        <!-- Category Breadcrumb -->
        <el-breadcrumb-item
          v-if="breadcrumbs.categorySlug && breadcrumbs.categoryLabel"
          :to="{
            name: 'Products',
            params: { category: breadcrumbs.categorySlug },
          }"
        >
          {{ breadcrumbs.categoryLabel }}
        </el-breadcrumb-item>

        <!-- Subcategory Breadcrumb -->
        <el-breadcrumb-item
          v-if="breadcrumbs.subcategorySlug && breadcrumbs.subcategoryLabel"
          :to="{
            name: 'Products',
            params: { category: breadcrumbs.categorySlug },
            hash: `#${breadcrumbs.subcategorySlug}`,
          }"
        >
          {{ breadcrumbs.subcategoryLabel }}
        </el-breadcrumb-item>

        <!-- Product Breadcrumb -->
        <el-breadcrumb-item>
          {{ breadcrumbs.productName }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </nav>
  </div>
</template>

<script>
import products from '.';
import { mapState } from 'vuex';

export default {
  name: 'ProductCategoryBreadcrumb',
  props: {
    product: {
      type: Object,
    },
  },
  computed: {
    ...mapState(products.store.namespace, ['products']),
    breadcrumbs() {
      const categoryData = this.product.newProductCategory.find(
        (v) => v.level === 1
      );
      const subcategoryData = this.product.newProductCategory.find(
        (v) => v.level === 2
      );
      return {
        categorySlug: categoryData ? categoryData.slug : undefined,
        categoryLabel: categoryData ? categoryData.title : undefined,
        subcategorySlug: subcategoryData ? subcategoryData.slug : undefined,
        subcategoryLabel: subcategoryData ? subcategoryData.title : undefined,
        productName: this.product?.title ?? '',
      };
    },
  },
};

//////////
</script>

<style lang="scss" scoped></style>
